import * as React from 'react';
import { useDispatch } from 'react-redux';

import { TThunkDispatch } from '../../../types/redux';
import { EStepCode, TNextStep } from '../../../types/form';
import { THandleCompleteQuiz, THandleFormSubmit } from '../types/internal';
import { useSetWebViewUrl } from '../../../utils/useSetWebViewUrl';

const isQuizCompleted = (nextStep: TNextStep) => nextStep.nextStepCode === EStepCode.FormSent;

export const useQuizCompleteControls = (handleSubmit: THandleFormSubmit) => {
  const { setIsFinishedQuery } = useSetWebViewUrl();
  const dispatch = useDispatch<TThunkDispatch>();
  const [quizCompleted, _setQuizCompleted] = React.useState(false);
  const [quizSubmitting, _setQuizSubmitting] = React.useState(false);

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  const [quizSubmitError, _setQuizSubmitError] = React.useState<string | null>(null);

  const handleCompleteQuiz = React.useCallback<THandleCompleteQuiz>(
    async (props, afterSubmitSuccess) => {
      _setQuizSubmitting(true);
      _setQuizSubmitError(null);

      const res = await dispatch(handleSubmit(props));

      if (res instanceof Error) {
        _setQuizSubmitError(res.message);
        _setQuizSubmitting(false);
        throw res;
      } else {
        /**
         * Внешний коллбэк, вызываемый после успешного сабмита и перед завершением опросника
         * Не менять положение вызова!
         * */
        afterSubmitSuccess();
        _setQuizCompleted(true);
        _setQuizSubmitting(false);
        setIsFinishedQuery();
      }
    },
    [_setQuizCompleted, setIsFinishedQuery, handleSubmit, dispatch],
  );

  return { quizCompleted, handleCompleteQuiz, isQuizCompleted, quizSubmitError, quizSubmitting };
};
